module.exports = __webpack_public_path__ + "static/img/redeem.a55d8bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-CN/redeem.png
// module id = W1fj
// module chunks = 1